import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook, Shield } from "lucide-react";
import { CLINIC } from "../lib/api";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-slate-300 mt-20">
      <div className="container-max py-16">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center text-white font-bold">
                P
              </div>
              <div className="leading-tight">
                <div className="font-bold text-white text-lg">Clínica Dental Pina</div>
                <div className="text-xs text-slate-400">Desde 1984</div>
              </div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Más de 40 años cuidando la sonrisa de Calafell y alrededores.
              Odontología de autor, atención integral y trato cercano.
            </p>
            <div className="flex gap-3 mt-5">
              <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center hover:bg-orange-600 transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center hover:bg-orange-600 transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              Servicios
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/implantes-dentales-calafell" className="hover:text-orange-400 transition-colors">Implantes dentales</Link></li>
              <li><Link to="/ortodoncia-invisible-calafell" className="hover:text-orange-400 transition-colors">Ortodoncia invisible</Link></li>
              <li><Link to="/estetica-dental" className="hover:text-orange-400 transition-colors">Estética dental</Link></li>
              <li><Link to="/odontopediatria" className="hover:text-orange-400 transition-colors">Odontopediatría</Link></li>
              <li><Link to="/urgencias-dentales-calafell" className="hover:text-orange-400 transition-colors">Urgencias</Link></li>
            </ul>
          </div>

          {/* Clinic */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              La clínica
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/dentista-calafell" className="hover:text-orange-400 transition-colors">Dentista en Calafell</Link></li>
              <li><Link to="/equipo" className="hover:text-orange-400 transition-colors">Nuestro equipo</Link></li>
              <li><Link to="/opiniones" className="hover:text-orange-400 transition-colors">Opiniones de pacientes</Link></li>
              <li><Link to="/blog" className="hover:text-orange-400 transition-colors">Blog dental</Link></li>
              <li><Link to="/contacto" className="hover:text-orange-400 transition-colors">Contacto</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              Contacto
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-orange-400 shrink-0" />
                <div>
                  {CLINIC.address}<br />
                  {CLINIC.city}<br />
                  {CLINIC.province}
                </div>
              </li>
              <li>
                <a href={`tel:${CLINIC.phone}`} className="flex gap-3 hover:text-orange-400 transition-colors" data-testid="footer-phone">
                  <Phone className="w-4 h-4 mt-0.5 text-orange-400 shrink-0" />
                  {CLINIC.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${CLINIC.email}`} className="flex gap-3 hover:text-orange-400 transition-colors break-all" data-testid="footer-email">
                  <Mail className="w-4 h-4 mt-0.5 text-orange-400 shrink-0" />
                  {CLINIC.email}
                </a>
              </li>
              <li className="flex gap-3">
                <Clock className="w-4 h-4 mt-0.5 text-orange-400 shrink-0" />
                <div className="text-xs">
                  Lun-Jue: 10-13h / 14-18h<br />
                  Mié y Vie: 10-14h
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Sanitary Registry */}
        <div className="mt-12 p-5 bg-slate-800/50 border border-slate-700 rounded-2xl flex items-center gap-4" data-testid="sanitary-registry">
          <Shield className="w-6 h-6 text-orange-400 shrink-0" />
          <div className="text-sm">
            <div className="font-semibold text-white">Centro sanitario autorizado</div>
            <div className="text-slate-400 text-xs mt-0.5">
              Número de registro sanitario: <span className="text-white font-mono">E43641950</span>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Clínica Dental Pina · Todos los derechos reservados</div>
          <div className="flex gap-5">
            <Link to="/aviso-legal" className="hover:text-orange-400">Aviso legal</Link>
            <Link to="/privacidad" className="hover:text-orange-400">Privacidad</Link>
            <Link to="/cookies" className="hover:text-orange-400">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
